module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"Perfil de Usuario":"Perfil de Usuario","Nombre de Usuario":"Nombre de Usuario","Empresa":"Empresa","Teléfono":"Teléfono","Email":"Email","Guardar":"Guardar"},"en":{"Perfil de Usuario":"User profile","Nombre de Usuario":"Username","Empresa":"Company","Teléfono":"Phone","Email":"Email","Guardar":"Save"}}')
  delete Component.options._Ctor
}
